// extracted by mini-css-extract-plugin
export default {"container":"Tabs_container__vtE3V","active":"Tabs_active__NEadN"};